export default __webpack_public_path__ + "228ab55a72ca913cd5f5018ba09a28bf.svg";